module.exports = __webpack_public_path__ + "static/media/05-img-05@3x.d4e62d62.webp";